import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/view/welcomePage/welcomePage";
import homePage from "@/view/homePage/homePage";
import Login from "@/view/Login/index";
import Forget from "@/view/Login/Forget";
import register from "@/view/Login/register";
import match from "@/view/Match/index";
import Contactus from "@/view/homePage/contactus";
import Work from "@/view/Work/index";
import wordList from "@/view/Work/list";
import wordList1 from "@/view/Work/list1";
import wordList2 from "@/view/Work/list2";
import wordList3 from "@/view/Work/list3";
import Signup from "@/view/Signup/index";
import workspace from "@/view/Match/workspace";
import lisence from "@/view/Match/lisence";
import cooperation from "@/view/Match/cooperation";
// import Solution from "@/view/Match/Solution";
import proposition from "@/view/Match/proposition";
import recruitment from "@/view/Match/recruitment";
import wordDetail from "@/view/Work/wordDetail";
import gongchengshi from "@/view/Work/gongchengshi";
import yunwei from "@/view/Work/yunwei";
import NewsDetail from "@/view/Match/NewsDetail.vue";
import PenghaiHCIE from "@/view/Match/PenghaiHCIE.vue";
import PenghaiDDI from '@/view/Match/PenghaiDDI.vue'
import PenghaiFinancial from '@/view/Match/PenghaiFinancial.vue'
import PenghaiCloud from '@/view/Match/PenghaiCloud.vue'
import PenghaiJiangxi from '@/view/Match/PenghaiJiangxi.vue'

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export const constantRoutes = [{
  path: "/welcomePage",
  component: HelloWorld,
  hidden: true,
  children: [{
    path: "welcomePage",
    name: "welcomePage",
    component: resolve =>
      require(["@/view/welcomePage/welcomePage"], resolve)
  }]
},
{
  path: "/",
  component: homePage,
  hidden: true,
  children: [{
    path: "homePage",
    name: "homePage",
    component: resolve => require(["@/view/homePage/homePage"], resolve)
  }]
},

{
  path: "/Login",
  component: Login,
  hidden: true,
  children: [{
    path: "Login",
    name: "Login",
    component: resolve => require(["@/view/Login/index"], resolve)
  }]
},
{
  path: "/Forget",
  component: Forget,
  hidden: true,
  children: [{
    path: "Forget",
    name: "Forget",
    component: resolve => require(["@/view/Login/Forget"], resolve)
  }]
},
{
  path: "/register",
  component: register,
  hidden: true,
  children: [{
    path: "register",
    name: "register",
    component: resolve => require(["@/view/Login/register"], resolve)
  }]
},
{
  path: "/match",
  component: match,
  hidden: true,
  children: [{
    path: "match",
    name: "match",
    component: resolve => require(["@/view/Match/index"], resolve)
  }]
},
{
  path: "/Contactus",
  component: Contactus,
  hidden: true,
  children: [{
    path: "Contactus",
    name: "Contactus",
    component: resolve => require(["@/view/homePage/contactus"], resolve)
  }]
},
{
  path: "/Work",
  component: Work,
  hidden: true,
  children: [{
    path: "Work",
    name: "Work",
    component: resolve => require(["@/view/Work/index"], resolve)
  }]
},
{
  path: "/Signup",
  component: Signup,
  hidden: true,
  children: [{
    path: "Signup",
    name: "Signup",
    component: resolve => require(["@/view/Signup/index"], resolve)
  }]
},
{
  path: "/workspace",
  component: workspace,
  hidden: true,
  children: [{
    path: "workspace",
    name: "workspace",
    component: resolve => require(["@/view/Match/workspace"], resolve)
  }]
},
{
  path: "/lisence",
  component: lisence,
  hidden: true,
  children: [{
    path: "lisence",
    name: "lisence",
    component: resolve => require(["@/view/Match/lisence"], resolve)
  }]
},

{
  path: "/cooperation",
  component: cooperation,
  hidden: true,
  props: true, // 添加这一行确保参数传递
  children: [{
    path: ":tab?", // 使用参数
    name: "cooperation",
    component: resolve => require(["@/view/Match/cooperation"], resolve),
    props: true
  }]
},

{
  path: '/solution',
  component: () => import('../view/Match/Solution.vue'), // 相对路径
  hidden: true
},


{
  path: "/design",
  component: resolve => require(["@/view/Match/design"], resolve)
},
{
  path: "/industrial",
  component: resolve => require(["@/view/Match/industrial"], resolve)
},
{
  path: "/innovate",
  component: resolve => require(["@/view/Match/innovate"], resolve)
},
{
  path: "/proposition",
  component: proposition,
  hidden: true,
  children: [{
    path: "proposition",
    name: "proposition",
    component: resolve => require(["@/view/Match/proposition"], resolve)
  }]
},
{
  path: "/Work/wordDetail",
  component: wordDetail,
  hidden: true,
  children: [{
    path: "wordDetail",
    name: "wordDetail",
    component: resolve => require(["@/view/Work/wordDetail"], resolve)
  }]
},

{
  path: "/Work/list",
  component: wordList,
  hidden: true,
  children: [{
    path: ":tab?", // 修改为这样
    name: "wordList",
    component: resolve => require(["@/view/Work/list"], resolve),
    props: true
  }]
},

{
  path: "/Work/list1",
  component: wordList1,
  hidden: true,
  children: [{
    path: "wordList1",
    name: "wordList1",
    component: resolve => require(["@/view/Work/list1"], resolve)
  }]
},
{
  path: "/Work/list2",
  component: wordList2,
  hidden: true,
  children: [{
    path: "wordList2",
    name: "wordList2",
    component: resolve => require(["@/view/Work/list2"], resolve)
  }]
},
{
  path: "/Work/list3",
  component: wordList3,
  hidden: true,
  children: [{
    path: "wordList3",
    name: "wordList3",
    component: resolve => require(["@/view/Work/list3"], resolve)
  }]
},
{
  path: "/recruitment",
  component: recruitment,
  hidden: true,
  children: [{
    path: "recruitment",
    name: "recruitment",
    component: resolve => require(["@/view/Match/recruitment"], resolve)
  }]
},
{
  path: "/gongchengshi",
  component: gongchengshi,
  hidden: true,
  children: [{
    path: "gongchengshi",
    name: "gongchengshi",
    component: resolve => require(["@/view/Work/gongchengshi"], resolve)
  }]
},
{
  path: "/yunwei",
  component: yunwei,
  hidden: true,
  children: [{
    path: "yunwei",
    name: "yunwei",
    component: resolve => require(["@/view/Work/yunwei"], resolve)
  }]
},
{
  path: "/news",
  name: "news",
  component: NewsDetail,
  hidden: true,
  children: [{
    path: "newsDetail:id",
    name: "NewsDetail",
    component: resolve => require(["@/view/Match/NewsDetail"], resolve)
  }]
},
{
  path: "/news/2",
  component: PenghaiDDI,
  hidden: true,
  children: [{
    path: "2",
    name: "PenghaiDDI",
    component: resolve => require(["@/view/Match/PenghaiDDI"], resolve)
  }]
},
{
  path: "/news/3",
  component: PenghaiFinancial,
  hidden: true,
  children: [{
    path: "3",
    name: "PenghaiFinancial",
    component: resolve => require(["@/view/Match/PenghaiFinancial"], resolve)
  }]
},
{
  path: "/news/4",
  component: PenghaiCloud,
  hidden: true,
  children: [{
    path: "4",
    name: "PenghaiCloud",
    component: resolve => require(["@/view/Match/PenghaiCloud"], resolve)
  }]
},
{
  path: "/news/5",
  component: PenghaiJiangxi,
  hidden: true,
  children: [{
    path: "5",
    name: "PenghaiJiangxi",
    component: resolve => require(["@/view/Match/PenghaiJiangxi"], resolve)
  }]
},
];

export default new Router({
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
});



// WEBPACK FOOTER //
// ./src/router/index.js